import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import StarsIcon from '@material-ui/icons/Stars';
import styled from 'styled-components';

//Components
import Header from './Header';
import Subtext from './Subtext';
import Chips from './Chips';
import ListCard from '../ListCard';

const ListCardStyled = styled(ListCard)`

`
const Content = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex: 1 0 auto;
  padding: 8px;
`
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`
//TODO: create info card models
const InfoCard = ({
  header,
  premium,
  subtext1,
  subtext2,
  chips,
  classes,
  theme,
  ...other
}) => {

  return (
    <ListCardStyled {...other}>
      <Content>
        <HeaderContainer>
        {premium && <StarsIcon fontSize='small' /> }
        <Header text={header} {...other} />
        </HeaderContainer>
        <Subtext text={subtext1}/>
        <Subtext text={subtext2}/>
        <Chips array={chips}/>
      </Content>
    </ListCardStyled>
  )
}

InfoCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  header: PropTypes.string,
  image: PropTypes.string,
  subtext1: PropTypes.string,
  subtext2: PropTypes.string,
  chips: PropTypes.array,
  onClick: PropTypes.func,
};

InfoCard.defaultProps = {
  // header: 'hello',
  // subtext1: '#warmup #dig #stuff',
  // image: 'https://i.pinimg.com/236x/2c/1f/7a/2c1f7a136015ddc87e2c6a2a4b42037d--happy-puppy-happy-dogs.jpg',
  // subtext2: 'ladder',
  // intensity_level: 2,
  // chips: ['arms','legs','chest'],
};

export default withStyles(null, { withTheme: true })(InfoCard);
